import React, { useContext, useEffect, useRef } from 'react';
import { AppContext } from '../window';

const TitleComponent: React.FC = () => {
  const { user } = useContext(AppContext);
  const originalTitleRef = useRef<string>();

  useEffect(() => {
    // Store the original title on mount
    if (!originalTitleRef.current) {
      originalTitleRef.current = document.title;
    }
  }, []);

  useEffect(() => {
    const unreadCount = user?.unreadMessageCount || 0;
    const originalTitle = originalTitleRef.current || document.title;

    if (unreadCount > 0) {
      document.title = `(${unreadCount}) ${originalTitle}`;
    } else {
      document.title = originalTitle;
    }
  }, [user?.unreadMessageCount]);

  return null;
};

export default TitleComponent;